import styled from 'styled-components'
import { Button } from 'antd'

export const StyledButton = styled(Button)`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: #ffc04d;
  color: #0d0c3b;
  font-weight: 700;
  font-size: 16px;
  border: 2px solid rgba(255, 255, 255, 0.18);
  padding: 18px 19px;
  border-radius: 50px;
  cursor: pointer;

  &:hover {
    background: #ffc04d !important;
    color: #030852 !important;
    border: 2px solid rgba(255, 255, 255, 0.18) !important;
  }

  &:hover .glow {
    opacity: 1;
  }

  .glow {
    content: '';
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(255, 166, 1, 0.88);
    pointer-events: none;
    filter: blur(10px);
    transform: translate(-50%, -50%);
    z-index: 1;
    transition: opacity 0.3s ease;
    opacity: 0;
  }

  span,
  svg {
    z-index: 2;
  }

  @media screen and (max-width: 376px) {
    font-size: 12px;
    padding: 16px 10px;
    gap: 4px;
  }
`

export const StarsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  z-index: 2;
  @media screen and (max-width: 376px) {
    width: 18px;
  }
`

export const Star = styled.img`
  width: 20px;
  @media screen and (max-width: 376px) {
    width: 16px;
  }
`
